/**
 * Card Product — Extracted from card-product.liquid
 * initOCSCard + terpene/cannabinoid popups + variant selection + add-to-cart
 * Loaded with defer from theme.liquid
 */
  (function() {
    // Use global strainColors from global.js (avoid redeclaration)
    var strainColors = window.strainColors || {
      "Sativa": "#ff0000",
      "Indica": "#00b346", 
      "Hybrid": "#0072c7",
      "#PassTheSmoke": "#fe5e02"
    };

    // Cannabinoid and terpene information
    const cannabinoidInfo = {
      thc: {
        name: "THC",
        fullName: "Tetrahydrocannabinol",
        color: "#FF4B4B",
        description: "The primary psychoactive compound in cannabis. THC is responsible for the euphoric and psychoactive effects commonly associated with cannabis.",
        effects: ["Euphoria", "Relaxation", "Creativity", "Increased appetite", "Altered perception"]
      },
      cbd: {
        name: "CBD",
        fullName: "Cannabidiol",
        color: "#4B7BFF",
        description: "A non-psychoactive compound that doesn't produce a 'high'. CBD may modulate some of THC's effects.",
        effects: ["Calming", "Clear-headed", "Relaxation", "Focus", "Balance"]
      },
      cbg: {
        name: "CBG",
        fullName: "Cannabigerol",
        color: "#FF9500",
        description: "Often called the 'mother cannabinoid' as it's the precursor to other cannabinoids. Non-psychoactive.",
        effects: ["Alertness", "Focus", "Clarity", "Mood boost", "Appetite"]
      },
      cbn: {
        name: "CBN",
        fullName: "Cannabinol",
        color: "#9B59B6",
        description: "Created when THC ages and oxidizes. Known for its deeply relaxing effects.",
        effects: ["Drowsiness", "Deep relaxation", "Calmness", "Sedation", "Tranquility"]
      },
      thcv: {
        name: "THCV",
        fullName: "Tetrahydrocannabivarin",
        color: "#2ECC71",
        description: "A compound with unique effects that may provide an energetic, clear-headed experience.",
        effects: ["Energy", "Focus", "Clarity", "Alertness", "Motivation"]
      },
      cbc: {
        name: "CBC",
        fullName: "Cannabichromene",
        color: "#FF69B4",
        description: "Works synergistically with other cannabinoids. Non-psychoactive.",
        effects: ["Mood elevation", "Relaxation", "Calmness", "Well-being", "Balance"]
      }
    };

    const terpeneInfo = {
      // Primary terpenes (most common)
      limonene: {
        name: "Limonene",
        aroma: "Citrus, lemon",
        description: "Found in citrus fruits, this terpene provides bright, uplifting aromas reminiscent of fresh lemons.",
        effects: ["Mood elevation", "Alertness", "Energy", "Refreshing", "Uplifting"]
      },
      "delta-limonene": {
        name: "Delta-Limonene",
        aroma: "Citrus, orange",
        description: "The most common form of limonene, providing sweet citrus notes.",
        effects: ["Mood elevation", "Alertness", "Energy", "Refreshing", "Uplifting"]
      },
      myrcene: {
        name: "Myrcene",
        aroma: "Earthy, musky, fruity",
        description: "The most common terpene in cannabis. Known for its deeply relaxing qualities.",
        effects: ["Sedation", "Relaxation", "Couch-lock", "Calmness", "Enhanced effects"]
      },
      "beta-myrcene": {
        name: "Beta-Myrcene",
        aroma: "Earthy, musky, fruity",
        description: "The most abundant form of myrcene in cannabis.",
        effects: ["Sedation", "Relaxation", "Couch-lock", "Calmness", "Enhanced effects"]
      },
      pinene: {
        name: "Pinene",
        aroma: "Pine, fresh",
        description: "Found in pine needles and many herbs. Provides a fresh, forest-like aroma.",
        effects: ["Alertness", "Memory", "Focus", "Clarity", "Energy"]
      },
      "alpha-pinene": {
        name: "Alpha-Pinene",
        aroma: "Pine, rosemary",
        description: "The most common terpene in nature, providing sharp pine notes.",
        effects: ["Alertness", "Memory", "Focus", "Clarity", "Energy"]
      },
      "beta-pinene": {
        name: "Beta-Pinene",
        aroma: "Pine, parsley",
        description: "Provides fresh, herbaceous pine notes.",
        effects: ["Alertness", "Focus", "Clarity", "Energy", "Refreshing"]
      },
      linalool: {
        name: "Linalool",
        aroma: "Floral, lavender",
        description: "Also found in lavender, known for its soothing and calming qualities.",
        effects: ["Calming", "Relaxation", "Mood balance", "Sedative", "Tranquility"]
      },
      caryophyllene: {
        name: "Caryophyllene",
        aroma: "Spicy, peppery",
        description: "Provides a warm, spicy aroma similar to black pepper and cloves.",
        effects: ["Relaxation", "Calmness", "Mood balance", "Soothing", "Grounding"]
      },
      "beta-caryophyllene": {
        name: "Beta-Caryophyllene",
        aroma: "Spicy, woody",
        description: "The only terpene that also acts as a cannabinoid.",
        effects: ["Relaxation", "Calmness", "Mood balance", "Soothing", "Grounding"]
      },
      "trans-caryophyllene": {
        name: "Trans-Caryophyllene",
        aroma: "Spicy, peppery",
        description: "A variant of caryophyllene with similar spicy notes.",
        effects: ["Relaxation", "Calmness", "Balance", "Soothing", "Grounding"]
      },
      humulene: {
        name: "Humulene",
        aroma: "Woody, earthy",
        description: "Found in hops and many spices. Provides an earthy, woody aroma.",
        effects: ["Focus", "Appetite control", "Alertness", "Clarity", "Grounding"]
      },
      "alpha-humulene": {
        name: "Alpha-Humulene",
        aroma: "Woody, hoppy",
        description: "Primary form of humulene, prominent in hops.",
        effects: ["Focus", "Appetite control", "Alertness", "Clarity", "Grounding"]
      },
      terpinolene: {
        name: "Terpinolene",
        aroma: "Floral, herbal, pine",
        description: "Less common but found in many cannabis strains. Has a complex, multi-layered aroma.",
        effects: ["Uplifting", "Creativity", "Energy", "Mood boost", "Relaxation"]
      },
      
      // Secondary terpenes
      "alpha-bisabolol": {
        name: "Alpha-Bisabolol",
        aroma: "Floral, honey",
        description: "Found in chamomile, provides sweet floral notes.",
        effects: ["Calming", "Soothing", "Relaxation", "Balance", "Gentle"]
      },
      bisabolol: {
        name: "Bisabolol",
        aroma: "Floral, sweet",
        description: "Provides delicate floral sweetness.",
        effects: ["Calming", "Soothing", "Relaxation", "Balance", "Gentle"]
      },
      ocimene: {
        name: "Ocimene",
        aroma: "Sweet, herbal, woody",
        description: "Provides sweet, herbaceous notes with woody undertones.",
        effects: ["Uplifting", "Energy", "Decongestant", "Alertness", "Refreshing"]
      },
      "beta-ocimene": {
        name: "Beta-Ocimene",
        aroma: "Sweet, herbal",
        description: "Sweet and herbaceous with citrus hints.",
        effects: ["Uplifting", "Energy", "Alertness", "Refreshing", "Mood boost"]
      },
      "trans-ocimene": {
        name: "Trans-Ocimene",
        aroma: "Sweet, woody",
        description: "Variant of ocimene with more woody notes.",
        effects: ["Uplifting", "Energy", "Focus", "Refreshing", "Clarity"]
      },
      nerolidol: {
        name: "Nerolidol",
        aroma: "Woody, fresh bark",
        description: "Found in jasmine and tea tree, provides fresh woody notes.",
        effects: ["Sedation", "Relaxation", "Calmness", "Tranquility", "Balance"]
      },
      "trans-nerolidol": {
        name: "Trans-Nerolidol",
        aroma: "Floral, woody",
        description: "Variant with more floral characteristics.",
        effects: ["Sedation", "Relaxation", "Calmness", "Dreams", "Tranquility"]
      },
      terpineol: {
        name: "Terpineol",
        aroma: "Floral, lilac",
        description: "Provides pleasant floral notes reminiscent of lilacs.",
        effects: ["Relaxation", "Sedation", "Calmness", "Balance", "Soothing"]
      },
      "alpha-terpineol": {
        name: "Alpha-Terpineol",
        aroma: "Pine, floral",
        description: "Common in pine oil with floral undertones.",
        effects: ["Relaxation", "Sedation", "Calmness", "Focus", "Soothing"]
      },
      camphene: {
        name: "Camphene",
        aroma: "Pungent, damp woods",
        description: "Provides sharp, forest-like aromas.",
        effects: ["Cooling", "Refreshing", "Focus", "Clarity", "Energy"]
      },
      geraniol: {
        name: "Geraniol",
        aroma: "Rose, floral",
        description: "Found in roses and geraniums, provides sweet floral notes.",
        effects: ["Uplifting", "Relaxation", "Mood balance", "Creativity", "Joy"]
      },
      eucalyptol: {
        name: "Eucalyptol",
        aroma: "Minty, cooling",
        description: "Found in eucalyptus, provides cooling minty notes.",
        effects: ["Alertness", "Cooling", "Focus", "Clarity", "Refreshing"]
      },
      fenchol: {
        name: "Fenchol",
        aroma: "Fresh, lemon, pine",
        description: "Provides fresh citrus-pine combination.",
        effects: ["Cooling", "Refreshing", "Focus", "Alertness", "Clarity"]
      },
      guaiol: {
        name: "Guaiol",
        aroma: "Pine, woody, rose",
        description: "Found in cypress pine with subtle rose notes.",
        effects: ["Calming", "Balance", "Grounding", "Relaxation", "Peace"]
      },
      farnesene: {
        name: "Farnesene",
        aroma: "Green apple, fruity",
        description: "Provides fresh, fruity notes reminiscent of green apples.",
        effects: ["Calming", "Uplifting", "Balance", "Mood boost", "Refreshing"]
      },
      
      // Less common terpenes
      "alpha-cedrene": {
        name: "Alpha-Cedrene",
        aroma: "Cedar, woody",
        description: "Found in cedar, provides warm woody notes.",
        effects: ["Grounding", "Calming", "Focus", "Stability", "Balance"]
      },
      cedrene: {
        name: "Cedrene",
        aroma: "Cedar, woody",
        description: "Provides characteristic cedar aroma.",
        effects: ["Grounding", "Calming", "Focus", "Warmth", "Stability"]
      },
      "alpha-santalene": {
        name: "Alpha-Santalene",
        aroma: "Sandalwood, woody",
        description: "Found in sandalwood, provides exotic woody notes.",
        effects: ["Meditation", "Grounding", "Calming", "Focus", "Spiritual"]
      },
      cymene: {
        name: "Cymene",
        aroma: "Sweet, citrus, woody",
        description: "Provides sweet citrus notes with woody undertones.",
        effects: ["Energy", "Focus", "Alertness", "Uplifting", "Clarity"]
      },
      "para-cymenene": {
        name: "Para-Cymenene",
        aroma: "Citrus, fresh",
        description: "Variant of cymene with brighter citrus notes.",
        effects: ["Energy", "Focus", "Refreshing", "Alertness", "Mood boost"]
      },
      farnesol: {
        name: "Farnesol",
        aroma: "Green, floral",
        description: "Provides fresh green floral notes.",
        effects: ["Calming", "Balance", "Soothing", "Relaxation", "Gentle"]
      },
      fenchone: {
        name: "Fenchone",
        aroma: "Camphor, fresh",
        description: "Provides fresh, camphor-like notes.",
        effects: ["Cooling", "Focus", "Clarity", "Energy", "Refreshing"]
      },
      germacrene: {
        name: "Germacrene",
        aroma: "Green, woody, spicy",
        description: "Complex aroma with green and spicy notes.",
        effects: ["Balance", "Grounding", "Focus", "Stability", "Clarity"]
      },
      phytol: {
        name: "Phytol",
        aroma: "Floral, balsamic",
        description: "Degradation product of chlorophyll with subtle floral notes.",
        effects: ["Relaxation", "Sedation", "Calmness", "Tranquility", "Rest"]
      },
      selinadienes: {
        name: "Selinadienes",
        aroma: "Woody, amber",
        description: "Provides warm, amber-like woody notes.",
        effects: ["Grounding", "Warmth", "Relaxation", "Comfort", "Balance"]
      },
      terpinene: {
        name: "Terpinene",
        aroma: "Woody, lemon",
        description: "Provides woody notes with citrus hints.",
        effects: ["Uplifting", "Energy", "Focus", "Clarity", "Refreshing"]
      },
      thujone: {
        name: "Thujone",
        aroma: "Menthol, camphor",
        description: "Found in wormwood and sage, provides minty notes.",
        effects: ["Stimulating", "Focus", "Clarity", "Energy", "Alertness"]
      },
      eudesmols: {
        name: "Eudesmols",
        aroma: "Sweet, woody",
        description: "Provides sweet woody notes with honey hints.",
        effects: ["Calming", "Balance", "Relaxation", "Comfort", "Soothing"]
      }
    };

    // Create popup elements
    function createPopupElements() {
      if (document.getElementById('ocs-popup-overlay')) return;
      
      const overlay = document.createElement('div');
      overlay.id = 'ocs-popup-overlay';
      overlay.className = 'ocs-popup-overlay';
      
      const popup = document.createElement('div');
      popup.id = 'ocs-info-popup';
      popup.className = 'ocs-info-popup';
      popup.innerHTML = `
        <div class="ocs-info-popup__header">
          <h3 class="ocs-info-popup__title">
            <span class="ocs-info-popup__color-dot"></span>
            <span class="ocs-info-popup__name"></span>
          </h3>
          <button class="ocs-info-popup__close" aria-label="Close popup">&times;</button>
        </div>
        <div class="ocs-info-popup__content"></div>
      `;
      
      document.body.appendChild(overlay);
      document.body.appendChild(popup);
      
      // Close handlers
      overlay.addEventListener('click', closePopup);
      popup.querySelector('.ocs-info-popup__close').addEventListener('click', closePopup);
      
      // Prevent closing when clicking inside popup
      popup.addEventListener('click', (e) => e.stopPropagation());
    }

    // Show popup function
    function showPopup(type, key) {
      createPopupElements();
      
      const popup = document.getElementById('ocs-info-popup');
      const overlay = document.getElementById('ocs-popup-overlay');
      const data = type === 'cannabinoid' ? cannabinoidInfo[key] : terpeneInfo[key];
      
      if (!data) return;
      
      // Update popup content
      const colorDot = popup.querySelector('.ocs-info-popup__color-dot');
      const nameEl = popup.querySelector('.ocs-info-popup__name');
      const contentEl = popup.querySelector('.ocs-info-popup__content');
      
      if (type === 'cannabinoid') {
        colorDot.style.background = data.color;
        colorDot.style.display = 'inline-block';
        nameEl.textContent = `${data.name} - ${data.fullName}`;
      } else {
        colorDot.style.display = 'none';
        nameEl.textContent = data.name;
      }
      
      let content = `<p>${data.description}</p>`;
      
      if (data.aroma) {
        content += `<p><strong>Aroma:</strong> ${data.aroma}</p>`;
      }
      
      if (data.effects && data.effects.length > 0) {
        content += `
          <div class="ocs-info-popup__effects">
            <div class="ocs-info-popup__effects-title">Common Effects:</div>
            <div class="ocs-info-popup__effects-list">
              ${data.effects.map(effect => `<span class="ocs-info-popup__effect">${effect}</span>`).join('')}
            </div>
          </div>
        `;
      }
      
      contentEl.innerHTML = content;
      
      // Show popup
      requestAnimationFrame(() => {
        overlay.classList.add('active');
        popup.classList.add('active');
      });
    }

    // Close popup function
    function closePopup() {
      const popup = document.getElementById('ocs-info-popup');
      const overlay = document.getElementById('ocs-popup-overlay');
      
      if (popup && overlay) {
        popup.classList.remove('active');
        overlay.classList.remove('active');
      }
    }

    // Get terpene color class based on aroma
    function getTerpeneColorClass(terpName) {
      const terpLower = terpName.toLowerCase();
      const terp = terpeneInfo[terpLower] || 
                   terpeneInfo[terpLower.replace(/[:\s]/g, '')] ||
                   terpeneInfo[terpLower.replace(/:/g, '').trim()];
      
      if (!terp || !terp.aroma) return 'terp-herbal'; // default
      
      const aroma = terp.aroma.toLowerCase();
      
      // Match aroma to color class
      if (aroma.includes('citrus') || aroma.includes('lemon') || aroma.includes('orange')) return 'terp-citrus';
      if (aroma.includes('pine') || aroma.includes('rosemary')) return 'terp-pine';
      if (aroma.includes('floral') || aroma.includes('flower') || aroma.includes('rose') || aroma.includes('lavender')) return 'terp-floral';
      if (aroma.includes('spicy') || aroma.includes('pepper')) return 'terp-spicy';
      if (aroma.includes('woody') || aroma.includes('wood') || aroma.includes('cedar') || aroma.includes('sandalwood')) return 'terp-woody';
      if (aroma.includes('earthy') || aroma.includes('musk')) return 'terp-earthy';
      if (aroma.includes('sweet') || aroma.includes('honey')) return 'terp-sweet';
      if (aroma.includes('mint') || aroma.includes('menthol') || aroma.includes('camphor') || aroma.includes('cooling')) return 'terp-minty';
      if (aroma.includes('fruit') || aroma.includes('apple')) return 'terp-fruity';
      
      return 'terp-herbal'; // default for herbal or unmatched
    }

    // Position wheel labels using trigonometry
    function positionWheelLabels(cardEl) {
      const labels = cardEl.querySelectorAll('.ocs-wheel-label[data-angle]');
      labels.forEach(label => {
        const angle = parseFloat(label.dataset.angle);
        // Convert from CSS conic-gradient angle (starts at top) to math angle (starts at right)
        // CSS: 0° = top, Math: 0° = right, so subtract 90° and flip Y
        const adjustedAngle = angle - 90;
        const labelDistance = 38;
        const angleRad = adjustedAngle * (Math.PI / 180);
        const labelX = Math.cos(angleRad) * labelDistance + 50;
        const labelY = Math.sin(angleRad) * labelDistance + 50;
        
        label.style.left = `${labelX}px`;
        label.style.top = `${labelY}px`;
      });
    }

    function syncSubmitButtonState(card) {
      if (!card) return;

      const form = card.querySelector('form.ocs-ajax-add');
      const submitBtn = form?.querySelector('.ocs-card__button');
      const variantInput = form?.querySelector('.ocs-variant-id');
      const variantButtons = card.querySelectorAll('.ocs-variant-circle[data-variant-id]');
      const hasVariantChoices = variantButtons.length > 0;
      const hasMultipleVariantChoices = variantButtons.length > 1;
      const selectedVariant = card.querySelector('.ocs-variant-circle.selected');
      const canAddToCart = !!(variantInput?.value && (!hasVariantChoices || selectedVariant));

      if (!submitBtn) return;

      if (canAddToCart) {
        const selectedTitle = selectedVariant?.dataset.variantTitle;
        const selectedPrice = selectedVariant?.dataset.variantPrice;
        submitBtn.textContent = hasMultipleVariantChoices && selectedTitle && selectedPrice ? `ADD ${selectedTitle} • ${selectedPrice}` : submitBtn.dataset.defaultLabel || 'ADD TO CART';
        submitBtn.classList.remove('disabled');
        submitBtn.disabled = false;
      } else {
        submitBtn.textContent = submitBtn.dataset.defaultLabel || 'CHOOSE SIZE';
        submitBtn.classList.add('disabled');
        submitBtn.disabled = true;
      }

      if (typeof card.__syncActionDockState === 'function') {
        card.__syncActionDockState();
      }
    }

    // Initialize cards
    function initOCSCard(cardEl) {
      if (!cardEl || cardEl.dataset.initialized) return;
      cardEl.dataset.initialized = 'true';

      // Color strain type
      const strainEl = cardEl.querySelector('.ocs-card__straintype');
      const strain = cardEl.dataset.defaultStraintype;
      if (strainEl && strain) {
        strainEl.style.color = strainColors[strain] || '#777';
      }

      // Store original price HTML and classes
      const priceEl = cardEl.querySelector('.ocs-price-text');
      if (priceEl && !priceEl.dataset.fromPrice) {
        priceEl.dataset.fromPrice = priceEl.innerHTML;
        priceEl.dataset.originalClasses = priceEl.className;
      }

      // Store original image for variant-swap restore. Do NOT flip loading to
      // eager here: that forced every card image on the page to download at
      // DOMContentLoaded, defeating lazy-loading below the fold (~4MB pages).
      const imgEl = cardEl.querySelector('.ocs-card__image');
      if (imgEl && !imgEl.dataset.defaultImage) {
        imgEl.dataset.defaultImage = imgEl.src;
      }

      // Position wheel labels
      positionWheelLabels(cardEl);
      
      // Add click handlers for cannabinoid labels
      cardEl.querySelectorAll('.ocs-wheel-label').forEach(label => {
        label.addEventListener('click', function(e) {
          e.stopPropagation();
          const cannabinoid = this.dataset.cannabinoid;
          if (cannabinoid) showPopup('cannabinoid', cannabinoid);
        });
      });
      
      // Add click handlers for micro-legend
      cardEl.querySelectorAll('.ocs-micro-legend span').forEach(span => {
        span.addEventListener('click', function(e) {
          e.stopPropagation();
          const cannabinoid = this.dataset.cannabinoid;
          if (cannabinoid && cannabinoidInfo[cannabinoid]) {
            showPopup('cannabinoid', cannabinoid);
          }
        });
      });
      
      
      // Check if there are more than 3 terpenes and add class if needed
      const terpenesContainer = cardEl.querySelector('.ocs-terpenes-tabs');
      const terpTabs = cardEl.querySelectorAll('.ocs-terp-tab');
      if (terpenesContainer) {
        // Count all chips including the total chip
        if (terpenesContainer.children.length > 3) {
          terpenesContainer.classList.add('has-many');
        }
        // Always reset scroll so first chip (TERPS total) is visible
        terpenesContainer.scrollLeft = 0;
      }

      // Keep variant rails centered when they still fit, and only switch to
      // scroll alignment when the buttons actually overflow the card width.
      const variantsContainer = cardEl.querySelector('.ocs-card__variants');
      const variantButtons = cardEl.querySelectorAll('.ocs-variant-circle');
      if (variantsContainer) {
        const syncVariantRailAlignment = () => {
          const hasOverflow = variantsContainer.scrollWidth > variantsContainer.clientWidth + 1;
          variantsContainer.classList.toggle('has-many-variants', variantButtons.length > 3 && hasOverflow);
          if (!hasOverflow) {
            variantsContainer.scrollLeft = 0;
          }
        };

        syncVariantRailAlignment();
        requestAnimationFrame(syncVariantRailAlignment);

        if (typeof ResizeObserver === 'function' && !variantsContainer.__variantRailResizeObserver) {
          const resizeObserver = new ResizeObserver(syncVariantRailAlignment);
          resizeObserver.observe(variantsContainer);
          variantsContainer.__variantRailResizeObserver = resizeObserver;
        }
      }

      syncSubmitButtonState(cardEl);

      // Add click handlers and colors for terpene tabs
      terpTabs.forEach(tab => {
        // Apply color based on terpene
        const terpName = tab.textContent.trim();
        const colorClass = getTerpeneColorClass(terpName);
        tab.classList.add(colorClass);
        
        tab.addEventListener('click', function(e) {
          e.stopPropagation();
          
          // Hide tooltip after first click
          const tooltip = cardEl.querySelector('.ocs-tooltip');
          if (tooltip) tooltip.classList.remove('show-once');
          
          // Extract terpene name and normalize it - keep hyphens
          const rawTerpene = this.textContent.trim();
          // Try multiple formats
          const terpeneVariants = [
            rawTerpene.toLowerCase(), // as-is lowercase
            rawTerpene.toLowerCase().replace(/[:\s]/g, ''), // remove colons and spaces
            rawTerpene.toLowerCase().replace(/:/g, '').trim() // remove just colons, keep hyphens
          ];
          
          // Find matching terpene info
          let matchedTerpene = null;
          for (const variant of terpeneVariants) {
            if (terpeneInfo[variant]) {
              matchedTerpene = variant;
              break;
            }
          }
          
          if (matchedTerpene) {
            showPopup('terpene', matchedTerpene);
          }
        });
      });
    }

    // Toggle variant selection
    window.toggleVariant = function(variantId, productId, buttonEl) {
      // Scope everything to the clicked card — avoids duplicate-ID collisions
      // when the same product appears more than once (rails, recommendations).
      const card = buttonEl.closest('.ocs-card');
      const form = buttonEl.closest('form');
      if (!card || !form) return;

      const variantInput = form.querySelector('.ocs-variant-id');
      const priceWrapper = card.querySelector('.ocs-price-wrapper');
      const priceEl = card.querySelector('.ocs-price-text');
      const imgEl = card.querySelector('.ocs-card__image');
      const strainEl = card.querySelector('.ocs-card__straintype');
      const allButtons = form.querySelectorAll('.ocs-variant-circle');

      // Toggle selection
      if (buttonEl.classList.contains('selected')) {
        if (allButtons.length <= 1) {
          variantInput.value = variantId;
          syncSubmitButtonState(card);
          return;
        }

        // Deselect
        buttonEl.classList.remove('selected');
        variantInput.value = '';

        // Reset price
        if (priceEl && priceEl.dataset.fromPrice) {
          priceEl.innerHTML = priceEl.dataset.fromPrice;
          priceEl.className = priceEl.dataset.originalClasses || 'ocs-price-text';
        }

        // Reset image
        if (imgEl && imgEl.dataset.defaultImage) {
          imgEl.src = imgEl.dataset.defaultImage;
        }

        // Reset strain
        if (strainEl) {
          const defaultStrain = card.dataset.defaultStraintype;
          strainEl.textContent = defaultStrain;
          const defaultColor = strainColors[defaultStrain] || '#777';
          strainEl.style.color = defaultColor;
        }

        // Reset wheel
        resetWheel(card);
      } else {
        // Select new variant
        allButtons.forEach(btn => btn.classList.remove('selected'));
        buttonEl.classList.add('selected');
        variantInput.value = variantId;

        // Update price
        const newPrice = buttonEl.dataset.variantPrice;
        const comparePrice = buttonEl.dataset.variantComparePrice;

        if (priceEl) {
          if (comparePrice) {
            priceEl.classList.add('on-sale');
            priceEl.innerHTML = `<span class="ocs-compare-price">${comparePrice}</span><span class="ocs-sale-price">${newPrice}</span>`;
          } else {
            priceEl.classList.remove('on-sale');
            priceEl.innerHTML = `<span class="ocs-sale-price">${newPrice}</span>`;
          }
        }

        // Update image
        const newImage = buttonEl.dataset.variantImage;
        if (imgEl && newImage) {
          imgEl.src = newImage;
        }

        // Update strain
        const newStrain = buttonEl.dataset.variantStrain;
        if (strainEl && newStrain) {
          strainEl.textContent = newStrain;
          const strainColor = strainColors[newStrain] || '#777';
          strainEl.style.color = strainColor;
        }

        // Update wheel
        updateWheel(card, buttonEl);
      }

      if (typeof card.__syncCollectionQtyVisibility === 'function') {
        card.__syncCollectionQtyVisibility();
      }

      syncSubmitButtonState(card);
    };

    // Update potency wheel
    function updateWheel(card, buttonEl) {
      const wheel = card.querySelector('.ocs-wheel');
      if (!wheel) return;

      // Build new gradient
      const cannabinoids = [
        {key: 'thc', color: '#FF4B4B', label: 'THC'},
        {key: 'cbd', color: '#4B7BFF', label: 'CBD'},
        {key: 'cbg', color: '#FF9500', label: 'CBG'},
        {key: 'cbn', color: '#9B59B6', label: 'CBN'},
        {key: 'thcv', color: '#2ECC71', label: 'THCV'},
        {key: 'cbc', color: '#FF69B4', label: 'CBC'}
      ];
      
      let gradientParts = [];
      let currentAngle = 0;
      let hasValues = false;

      // Build gradient string
      cannabinoids.forEach(canno => {
        // Fix data attribute access - dataset converts data-variant-thc to variantThc
        const dataKey = 'variant' + canno.key.charAt(0).toUpperCase() + canno.key.slice(1);
        const value = parseFloat(buttonEl.dataset[dataKey]) || 0;
        
        if (value > 1) {
          hasValues = true;
          const sweep = value * 3.6;
          const endAngle = currentAngle + sweep;
          gradientParts.push(`${canno.color} ${currentAngle}deg ${endAngle}deg`);
          currentAngle = endAngle;
        }
      });

      // Update wheel
      const wheelInner = wheel.querySelector('.ocs-wheel-inner');
      if (wheelInner) {
        if (hasValues) {
          // Add gray for remaining portion if needed
          if (currentAngle < 360) {
            gradientParts.push(`#e0e0e0 ${currentAngle}deg 360deg`);
          }
          const gradientString = `conic-gradient(${gradientParts.join(', ')})`;
          wheelInner.style.background = gradientString;
        } else {
          wheelInner.style.background = '#e0e0e0';
        }
      }
      
      // Update potency ring
      const potencyRing = wheel.querySelector('.ocs-potency-ring');
      if (potencyRing) {
        const thcValue = parseInt(buttonEl.dataset.variantThc) || 0;
        let potencyColor;
        if (thcValue > 19) {
          potencyColor = '#ff4d4f';
        } else if (thcValue > 10) {
          potencyColor = '#ffc04d';
        } else {
          potencyColor = '#dcdcdc';
        }
        potencyRing.style.borderColor = potencyColor;
      }
      
      // Update mobile bar
      const mobileBar = card.querySelector('.ocs-mobile-bar');
      if (mobileBar) {
        const thcValue = parseInt(buttonEl.dataset.variantThc) || 0;
        const barFill = mobileBar.querySelector('.ocs-bar-fill');
        const barLabel = mobileBar.querySelector('.ocs-bar-label');
        if (barFill) barFill.style.width = `${thcValue}%`;
        if (barLabel) barLabel.textContent = `THC ${thcValue}%`;
      }

      // Update labels
      const labelsContainer = wheel.querySelector('.ocs-wheel-labels');
      if (labelsContainer) {
        labelsContainer.innerHTML = '';
        currentAngle = 0;
        
        cannabinoids.forEach(canno => {
          const dataKey = 'variant' + canno.key.charAt(0).toUpperCase() + canno.key.slice(1);
          const value = parseInt(buttonEl.dataset[dataKey]) || 0;
          
          if (value > 1) {
            const sweep = value * 3.6;
            const midAngle = currentAngle + (sweep / 2);
            
            const label = document.createElement('div');
            label.className = 'ocs-wheel-label';
            label.dataset.angle = midAngle;
            const displayKey = 'variant' + canno.key.charAt(0).toUpperCase() + canno.key.slice(1) + 'Display';
            const displayValue = buttonEl.dataset[displayKey] || `${value}%`;
            
            // Calculate precise position using trigonometry
            const adjustedAngle = midAngle - 90; // Convert CSS angle to math angle
            const labelDistance = 38;
            const midAngleRad = adjustedAngle * (Math.PI / 180);
            const labelX = Math.cos(midAngleRad) * labelDistance + 50;
            const labelY = Math.sin(midAngleRad) * labelDistance + 50;
            
            label.style.left = `${labelX}px`;
            label.style.top = `${labelY}px`;
            label.innerHTML = `<span class="label-text">${displayValue}</span>`;
            labelsContainer.appendChild(label);
            
            // Add click handler
            label.addEventListener('click', function(e) {
              e.stopPropagation();
              if (cannabinoidInfo[canno.key]) {
                showPopup('cannabinoid', canno.key);
              }
            });
            
            currentAngle += sweep;
          } else if (value > 0) {
            // Still calculate angle for values between 0-1%
            const sweep = value * 3.6;
            currentAngle += sweep;
          }
        });
      }
      
      // Update micro legend
      let legendContainer = card.querySelector('.ocs-micro-legend');
      if (!legendContainer) {
        // Create container if it doesn't exist
        const containerWrapper = card.querySelector('.ocs-micro-legend-container');
        if (containerWrapper) {
          legendContainer = containerWrapper.querySelector('.ocs-micro-legend');
        }
      }
      if (legendContainer) {
        legendContainer.innerHTML = '';
        const strainText = buttonEl.dataset.variantStrainDisplay || '';

        if (strainText) {
          strainText.split(' / ').forEach(s => {
            const span = document.createElement('span');
            span.className = 'ocs-strain-pill';
            span.style.background = 'linear-gradient(135deg, #FF4B4B, #FF4B4Bdd)';
            span.textContent = s;
            legendContainer.appendChild(span);
          });
        }

        cannabinoids.forEach(canno => {
          if (strainText && canno.key === 'thc') return;
          const dataKey = 'variant' + canno.key.charAt(0).toUpperCase() + canno.key.slice(1);
          const value = parseInt(buttonEl.dataset[dataKey]) || 0;
          
          if (value > 1) {
            const displayKey = 'variant' + canno.key.charAt(0).toUpperCase() + canno.key.slice(1) + 'Display';
            const displayValue = buttonEl.dataset[displayKey] || `${value}%`;
            const span = document.createElement('span');
            span.style.background = `linear-gradient(135deg, ${canno.color}, ${canno.color}dd)`;
            span.textContent = `${canno.label} ${displayValue}`;
            span.style.cursor = 'pointer';
            
            // Add click handler
            span.addEventListener('click', function(e) {
              e.stopPropagation();
              if (cannabinoidInfo[canno.key]) {
                showPopup('cannabinoid', canno.key);
              }
            });
            
            legendContainer.appendChild(span);
          }
        });
      }
    }

    // Reset wheel to default
    function resetWheel(card) {
      const wheel = card.querySelector('.ocs-wheel');
      if (!wheel) return;

      // Get original gradient from data attribute
      const wheelInner = wheel.querySelector('.ocs-wheel-inner');
      if (wheelInner) {
        const originalGradient = wheelInner.dataset.gradient;
        if (originalGradient) {
          const currentAngle = originalGradient.split(' ').pop().replace('deg', '') || 0;
          if (currentAngle < 360) {
            wheelInner.style.background = `conic-gradient(${originalGradient}, #e0e0e0 ${currentAngle}deg 360deg)`;
          } else {
            wheelInner.style.background = `conic-gradient(${originalGradient})`;
          }
        } else {
          wheelInner.style.background = '#e0e0e0';
        }
      }

      // Reset labels by recreating them from wheel's HTML
      const labelsContainer = wheel.querySelector('.ocs-wheel-labels');
      if (labelsContainer) {
        // Labels are already in the correct positions from initial render
        // Just ensure they're visible
        labelsContainer.querySelectorAll('.ocs-wheel-label').forEach(label => {
          label.style.display = 'block';
        });
      }
    }

    // AJAX add to cart (singleton — registers once no matter how many cards render)
    if (!window.__ocsSubmitHandler) {
      window.__ocsSubmitHandler = true;
      document.addEventListener('submit', async function(e) {
        const form = e.target;
        if (!form.classList.contains('ocs-ajax-add')) return;

        e.preventDefault();
        e.stopImmediatePropagation();

        // In-flight lock: swallow rapid double-submits while an add is pending or animating.
        if (form.dataset.ocsAdding === '1') return;

        const variantInput = form.querySelector('.ocs-variant-id');
        if (!variantInput || !variantInput.value) return;
        form.dataset.ocsAdding = '1';

        const btn = form.querySelector('.ocs-card__button');
        const card = form.closest('.ocs-card, .card--product, .product-card, .grid__item');
        const dock = card && card.querySelector('.ocs-atc-dock');
        const originalText = btn.textContent;
        btn.disabled = true;
        btn.classList.add('is-loading');
        btn.setAttribute('aria-label', 'Adding to cart');
        btn.innerHTML = '<span class="ocs-loading-dots" aria-hidden="true"><i></i><i></i><i></i></span><span>Adding</span>';
        if (dock) dock.classList.add('is-adding');

        try {
          const fd = new FormData(form);
          fd.set('id', variantInput.value);

          // Product-card +/- controls display the current cart quantity. A card
          // submit should add one unit only; existing quantity changes go through
          // /cart/change.js in collection-quantity-selector.js.
          const qty = '1';
          fd.delete('quantity');
          fd.set('quantity', qty);

          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams(fd)
          });

          if (!response.ok) {
            let addErr = 'Failed to add to cart';
            try {
              const errData = await response.clone().json();
              if (response.status === 422 || /max|stock|quantity/i.test((errData && (errData.description || errData.message)) || '')) {
                addErr = 'MAX IN CART';
              }
            } catch (e) {}
            throw new Error(addErr);
          }

          requestCartRefresh('ocs-card:add');

          btn.classList.remove('is-loading');
          btn.classList.add('is-success');
          btn.setAttribute('aria-label', 'Added to cart');
          btn.innerHTML = '<svg viewBox="0 0 18 18" fill="none" aria-hidden="true"><path d="M4 9.3l3.1 3.1L14 5.8" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg><span>Added</span>';
          if (dock) {
            dock.classList.remove('is-adding');
            dock.classList.add('is-added');
          }
          setTimeout(() => {
            if (card && typeof card.__setActionDockAdded === 'function') {
              card.__setActionDockAdded(variantInput.value);
            }
            btn.textContent = originalText;
            btn.removeAttribute('aria-label');
            btn.classList.remove('is-success', 'is-loading');
            btn.disabled = false;
            if (dock) dock.classList.remove('is-added', 'is-adding');
            if (card) {
              syncSubmitButtonState(card);
            }
            form.dataset.ocsAdding = '';
          }, 700);

          updateBOGOMessaging();
        } catch (error) {
          console.error('Add to cart error:', error);
          if (dock) dock.classList.remove('is-adding', 'is-added');
          btn.classList.remove('is-loading', 'is-success');
          btn.removeAttribute('aria-label');
          btn.textContent = (error && error.message === 'MAX IN CART') ? 'MAX IN CART' : 'ERROR';
          setTimeout(() => {
            btn.textContent = originalText;
            btn.disabled = false;
            if (card) syncSubmitButtonState(card);
            form.dataset.ocsAdding = '';
          }, 1500);
        }
      }, true);
    }

    function requestCartRefresh(source) {
      if (window.SmokeysCart?.refreshCart) {
        window.SmokeysCart.refreshCart(source);
        return;
      }

      fetch('/cart.js', { credentials: 'same-origin' })
        .then(res => (res.ok ? res.json() : null))
        .then(cart => {
          if (!cart) return;
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart, source } }));
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, source } }));
        })
        .catch(() => {});
    }

    // BOGO messaging update
    function updateBOGOMessaging() {
      // AGLC 6.2.9: when the Pick-&-Mix promo is OFF, no .ocs-card__bogo-message elements are
      // rendered, so there is nothing to update — and we must NOT show quantity-based discount
      // copy ("Add a 3rd item and get it 20% off", etc.). Short-circuit before fetching the cart.
      if (!document.querySelector('.ocs-card__bogo-message')) return;
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          const count = cart.item_count;
          document.querySelectorAll('.ocs-card__bogo-message').forEach(el => {
            if (count === 0 || count > 4) {
              el.innerHTML = `
                <span class="bogo-header">💨 Smokey's Pick-&-Mix</span>
                <span class="bogo-line">Buy 2 → Get 3rd item 20% off</span>
                <span class="bogo-line">Buy 3 → Get 4th item 30% off</span>
                <span class="bogo-line">Buy 4 → Get 5th item FREE</span>
                <span class="bogo-note">Offers cannot be combined</span>
              `;
            } else if (count === 1) {
              el.innerHTML = '<span class="bogo-header">💨 Smokey\'s Pick-&-Mix</span><span class="bogo-line">Add 1 more to get 20% off a 3rd item!</span>';
            } else if (count === 2) {
              el.innerHTML = '<span class="bogo-header">💨 Smokey\'s Pick-&-Mix</span><span class="bogo-line">Add a 3rd item and get it 20% off!</span>';
            } else if (count === 3) {
              el.innerHTML = '<span class="bogo-header">💨 Smokey\'s Pick-&-Mix</span><span class="bogo-line">Add a 4th item and get it 30% off!</span>';
            } else if (count === 4) {
              el.innerHTML = '<span class="bogo-header">💨 Smokey\'s Pick-&-Mix</span><span class="bogo-line">Add a 5th item and get it FREE!</span>';
            }
          });
        })
        .catch(err => console.error('Error updating BOGO:', err));
    }

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    function init() {
      // Initialize existing cards
      document.querySelectorAll('.ocs-card').forEach(initOCSCard);

      // Watch for new cards
      const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === 1) {
              if (node.classList && node.classList.contains('ocs-card')) {
                initOCSCard(node);
              }
              const cards = node.querySelectorAll ? node.querySelectorAll('.ocs-card') : [];
              cards.forEach(initOCSCard);
            }
          });
        });
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      // Listen for Shopify events
      document.addEventListener('shopify:section:load', () => {
        setTimeout(() => {
          document.querySelectorAll('.ocs-card').forEach(initOCSCard);
        }, 100);
      });

      // Initial BOGO update
      updateBOGOMessaging();
      
      // Listen for cart updates
      document.addEventListener('cart:refresh', updateBOGOMessaging);
    }
    
    // Drawer JS loaded from assets/review-drawer.js via theme.liquid

    // Expose initOCSCard to window for infinite scroll
    window.initOCSCard = initOCSCard;

  })();
